module.exports = __webpack_public_path__ + "static/49gde-f1ef3fd11e0c4962de02f2aa338eeb78.gif";